import { makeVar } from '@apollo/client';

export const accountStatementIndicator = {
    statementIndicatorId: null,
    code: '',
    name: '',
    attributeName: '',
    expression: '',
    financialIndicatorId: null,
    financialIndicatorName: '',
    orderNo: 1,
    computeOrder: 1,
    readOnlyYN: false,
    visibleYN: true,
    isInEditing: true
  };

export const accountStatementIndicatorModalVar = makeVar({ open: false, item: accountStatementIndicator });
